import React from 'react';

import classNames from 'classnames';

import { determineBgColor } from './utils/styleHelper';

type Props = Omit<React.HTMLProps<HTMLDivElement>, 'onChange' | 'value' | 'label'> & {
  refinedOnClick: () => void;
  disabled?: boolean;
  small?: boolean;
  active?: boolean;
  selected?: boolean;
};

export const NewEntryButton: React.FC<Props> = ({
  refinedOnClick,
  disabled,
  small,
  active,
  selected,
  children,
}) => (
  <button
    type="button"
    disabled={disabled}
    onClick={refinedOnClick}
    className={classNames(
      'flex items-center p-sm pr-md text-primary hover:action-bg-neutral-hover active:action-bg-neutral-pressed w-full outline-none',
      determineBgColor(selected, active),
      {
        'action-bg-neutral-disabled! text-disabled! hover:action-bg-neutral-disabled! active:action-bg-neutral-disabled!':
          disabled,
        'p-xs! pr-xxs!': small,
      },
    )}
  >
    {children}
  </button>
);
